export enum AccountingTransactionType {
  Transaction = "Transaction",
  AuthorizationHold = "AuthorizationHold",
}
